import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLabelComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-label/mapfre-label.component';
import { ImpNoticeComponent } from '../../../imp-notice/imp-notice.component';
import { OdometerSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/odometer-svg/odometer-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AgentNotificationService } from '../../../../../../_services/agent/agent-notification.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { ActivatedRoute, Router , RouterModule } from '@angular/router';
import {
  FormBaseControlService,
  AlertService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { FormGroup, FormControl, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { MileageService } from '../../../../../../_services/my-insurance/mileage.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreCardComponent, OdometerSvgComponent, ImpNoticeComponent, MapfreLabelComponent, MapfreButtonComponent],
  selector: 'app-odometer-update',
  templateUrl: './odometer-update.component.html',
  styleUrls: ['./odometer-update.component.scss'],
})
export class OdometerUpdateComponent implements OnInit {
  policyData: any;

  mileageData: {
    vin: string;
    mileage: string;
    vehicle: string;
    policyNumber: string;
  };
  subscription: any;
  policyNumber: any;
  vehicleDetails: any;
  odometerForm: FormGroup = new FormGroup({});
  inputs: any;
  errorMessage: any;
  showError = false;
  loader: boolean;
  isAcmic = false;

  constructor(
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute,
    private formBaseService: FormBaseControlService,
    private location: Location,
    private storageService: StorageServiceObservablesService,
    private mileageService: MileageService,
    private alertService: AlertService,
    private router: Router,
    private errorRedirectionService: ErrorRedirectionService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private acmicService: AcmicService,
    private agentNotification: AgentNotificationService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.formIputs();

    this.activatedRoute.params.subscribe((params) => {
      this.policyNumber = params.policyid;
      const index = params.index;
      this.policyDataService.$policyDetails.subscribe((policyData) => {
        if (policyData) {
          this.vehicleDetails = policyData.filter(
            (policy) => policy.policynumber.policyNumber == this.policyNumber
          )[0].vehicle[index];
          this.odometerForm.controls.updateMileage.setValue(
            this.vehicleDetails && this.vehicleDetails.odometerReading > 0
              ? this.vehicleDetails.odometerReading.toLocaleString()
              : ''
          );
        }
      });
    });
  }

  formIputs() {
    this.odometerForm.addControl(
      'updateMileage',
      new FormControl(null, [Validators.required])
    );
    this.odometerForm.addControl(
      'legalCheckMark',
      new FormControl(null, [Validators.required])
    );
  }

  goBack() {
    this.location.back();
  }

  checkMileage() {
    this.showError = false;
  }

  createChangeMileageDTO(odometerData) {
    return {
      updatedVehicleMileages: odometerData,
      header: this.agentNotification.getHeader(),
    };
  }

  updateOdometer() {
    const mileage = this.odometerForm.controls.updateMileage.value.replace(
      /\D/g,
      ''
    );
    const email = this.storageService.getUserFromStorage();
    const odometerReadingData = [];
    if (mileage <= this.vehicleDetails.odometerReading) {
      this.errorMessage = 'VALUE_LESS_THAN_ORIGINAL';
      this.showError = true;
      this.gTagService.triggerFormLink(
        'odometerForm',
        'false',
        this.translate.instant('VALUE_LESS_THAN_ORIGINAL')
      );
    } else if (mileage >= 1000000) {
      this.errorMessage = 'MILEAGE_MAX_LIMIT';
      this.showError = true;
      this.gTagService.triggerFormLink(
        'odometerForm',
        'false',
        this.translate.instant('MILEAGE_MAX_LIMIT')
      );
    } else {
      this.loader = true;
      odometerReadingData.push({
        Id: this.vehicleDetails.vehicleIdentificationNumber.Id || '',
        odoMeterReading: mileage,
        oldMileage: this.vehicleDetails.odometerReading,
      });
      const changeMileageDTO = this.createChangeMileageDTO(odometerReadingData);
      this.mileageService
        .updateMileage(email, this.policyNumber, changeMileageDTO)
        .subscribe(
          () => {
            this.gTagService.triggerFormLink('odometerForm', 'true', '');
            this.alertService.success(
              'Please allow us up to 5 business days to check and update your request.',
              true,
              'Mileage information received!'
            );
            this.router.navigate([
              'my-insurance',
              this.policyNumber,
              'details',
            ]);
            this.loader = false;
          },
          (error) => {
            this.loader = false;
            this.gTagService.triggerFormLink(
              'odometerForm',
              'false',
              this.translate.instant('PROBLEM_UPDATING_MILEAGE')
            );
            if (
              error.status === 400 ||
              error.status === 401 ||
              error.status === 403 ||
              error.status === 404 ||
              error.status === 408
            ) {
              this.alertService.error('PROBLEM_UPDATING_MILEAGE', true);
            } else {
              this.errorRedirectionService.errorRedirectHandler(
                error,
                this.policyNumber
              );
            }
          }
        );
    }
  }

  isNumeric(e) {
    const keyCode = e.which ? e.which : e.keyCode;
    const ret =
      (keyCode >= 48 && keyCode <= 57) ||
      keyCode == 44 ||
      [8, 9, 27, 13].indexOf(keyCode) != -1;
    return ret;
  }
}
